import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../context/user-context";

import useScrollTrigger from "../hooks/scroll-trigger";
import { Container, Fade, Grid } from "@mui/material";
import ThemeCard from "../components/card/theme-card";
import "../custom.d.ts";
import "./style.scss";
import Banner from "../components/banner/banner";
import ContactForm from "../components/form/contact-form";
import { BSGAPI } from "../auth/bsg-api";
import { ContextService } from "../context/context-service";
import { DWebContent } from "../model";
import VideoThemeCard from "../components/card/video-theme-card";
import DeveloperModeIcon from "@mui/icons-material/DeveloperMode";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import SpeedIcon from "@mui/icons-material/Speed";
import Loading from "../components/loading/loading";
import UMap from "../ubq/u-map";

const Home = (props: any) => {
  //const { children, window } = props;
  const { t, i18n } = useTranslation("content");

  const context = useContext(UserContext);

  const [webContent, setWebContent] = useState({} as DWebContent);

  const myRefWe = useRef<HTMLDivElement>(null);

  const getTrigger = useScrollTrigger();

  const [triggerWe, setTriggerWe] = useState(
    getTrigger(myRefWe.current).trigger
  );

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    window.onscroll = () => {
      setTriggerWe(getTrigger(myRefWe.current).trigger);
    };

    BSGAPI.getWebContent("home").then((json) => {
      let webContent = json as DWebContent;
      setWebContent(webContent);
      document.title = `${ContextService.SITE_NAME}:${webContent.title}`;
      setLoading(false);
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Loading show={loading} />
      {webContent.theme && (
        <VideoThemeCard
          backgroundVideo={webContent.theme.video}
          opacity={0.9}
          title={webContent.theme.title as string}
          description={webContent.theme.description as string}
          minHeight={webContent.theme.height}
          caption={webContent.theme.caption}
          route={webContent.theme.route}
          routeText={webContent.theme.routeText}
        >
          <Container maxWidth="md">
            <div className="section">
              <h1 className="center secondary-light">
                {webContent.theme.h1?.title}
              </h1>
              {webContent.theme.h1?.children?.map((child) => {
                return (
                  <h2 className="center secondary-light">{child.content}</h2>
                );
              })}
            </div>
          </Container>

          <Container maxWidth="md">
            <UMap
              id="map-id-home-7688"
              src="https://my-bsg-asset.s3.amazonaws.com/map/map_sample3.png"
              refresh={1000}
              markerSize={6}
              step={30}
              width="100%"
              height="400px"
            />
          </Container>

          <Container maxWidth="md">
            <h1></h1>
            <Grid
              container
              spacing={6}
              justifyContent="center"
              alignItems="stretch"
            >
              <Grid
                item
                xs={10}
                sm={6}
                md={4}
                lg={4}
                justifyContent="center"
                alignContent="center"
              >
                <h1 className="center secondary-light">
                  <LightbulbIcon style={{ fontSize: 60 }} />
                  <br />
                  Innovation
                </h1>
                <h2 className="center primary-light">
                  We bring great ideas and form product concepts.
                </h2>
              </Grid>
              <Grid
                item
                xs={10}
                sm={6}
                md={4}
                lg={4}
                justifyContent="center"
                alignContent="center"
              >
                <h1 className="center secondary-light">
                  <SpeedIcon style={{ fontSize: 60 }} />
                  <br />
                  Protoyping
                </h1>
                <h2 className="center primary-light">
                  We build Proo-of-Concept and product prototype for A/B
                  testing, angel investment and mature it for market.
                </h2>
              </Grid>
              <Grid
                item
                xs={10}
                sm={6}
                md={4}
                lg={4}
                justifyContent="center"
                alignContent="center"
              >
                <h1 className="center secondary-light">
                  <DeveloperModeIcon style={{ fontSize: 60 }} />
                  <br />
                  Development
                </h1>
                <h2 className="center primary-light">
                  We help you bring great ideas to life.
                </h2>
              </Grid>
            </Grid>
          </Container>

          <Container maxWidth="md">
            <div className="section">
              <h2 className="center secondary-light">
                {webContent.theme.h2?.title}
              </h2>
              {webContent.theme.h2?.children?.map((child, index) => {
                return (
                  <h3 className="center secondary-light" key={`h3-${index}`}>
                    {child.content}
                  </h3>
                );
              })}
            </div>
          </Container>
        </VideoThemeCard>
      )}

      <Fade in={triggerWe} timeout={4000}>
        <div ref={myRefWe}>
          <Banner>
            <Grid
              container
              direction="column"
              justifyContent="flex-start"
              alignContent="flex-start"
            >
              <Grid
                container
                item
                xs={12}
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <h1>{webContent.h1?.title}</h1>
              </Grid>
              {webContent.h1?.children?.map((child, index) => {
                return (
                  <Grid
                    key={`grid-${index}`}
                    container
                    item
                    xs={12}
                    justifyContent="flex-start"
                    alignItems="flex-start"
                  >
                    <h2>{child.content}</h2>
                  </Grid>
                );
              })}
            </Grid>
          </Banner>
        </div>
      </Fade>

      <div className="center">
        <ContactForm />
      </div>
    </div>
  );
};

export default Home;
